/**
 * エージェントの顔・名前を取得する共有フック。
 * Chat のメッセージアバター表示などで使う。プロファイル未設定・取得失敗時は
 * 中立（名前なし・アイコンなし→呼び出し側で 🤖 等にフォールバック）。
 */
import { useEffect, useState } from "react"
import { useAuth } from "@/hooks/useAuth"
import { getAvatarUrl, getProfile } from "@/services/boardService"

export type AgentFaceInfo = {
  agentName: string
  icon: string
  avatarUrl: string
}

export function useAgentProfile(): AgentFaceInfo {
  const { user } = useAuth()
  const [info, setInfo] = useState<AgentFaceInfo>({ agentName: "", icon: "", avatarUrl: "" })

  useEffect(() => {
    const idToken = user?.id_token
    if (!idToken) return
    let cancelled = false
    ;(async () => {
      try {
        const p = await getProfile(idToken)
        if (cancelled) return
        let avatarUrl = ""
        if (p.avatar === "image") {
          try {
            avatarUrl = (await getAvatarUrl(idToken)).url
          } catch {
            /* 画像なしはフォールバック */
          }
        }
        if (!cancelled) setInfo({ agentName: p.agentName || "", icon: p.icon || "", avatarUrl })
      } catch {
        /* プロファイル未設定は正常系 */
      }
    })()
    return () => {
      cancelled = true
    }
  }, [user?.id_token])

  return info
}
